module.exports = __webpack_public_path__ + "static/photo_8-77781603bf8abfa6cd2a4569fa793123.jpg";